// extracted by mini-css-extract-plugin
export default {"list":"list_TagList-module__SK_L","content":"content_TagList-module_3qyCf","reverse":"reverse_TagList-module_3Vjqh","tag":"tag_TagList-module_6hHWe"};